import {EditHardwareGroupWithContent} from "./HwEditingContextProvider";
import {PrepManager} from "./prepCanvas/PrepManager";
import React from "react";
import {useHwAPI} from "./HardwareGeneric";
import {useReloader} from "./ReloadContext";
import {hasCustomPrep} from "../../quote/openings/QuoteOpenings";

export function HwUpdateCustomPreps(props: {
    value: EditHardwareGroupWithContent;
    onDone(): void;
}) {

    const hapi = useHwAPI();
    const reloadRef = useReloader();

    return (
        <PrepManager
            title={"Confirm Prep Locations"}
            value={props.value as any}
            clearExisting
            noRegularCancel
            onCancel={props.onDone}
            onDone={async (config) => {
                await hapi.upsert({
                    value: Object.assign({}, props.value, {
                        prepConfigJson: config,
                        prepConfigIsCustom: hasCustomPrep(config),
                    }),
                })

                reloadRef.current();
                props.onDone();
            }}/>
    )
}